import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const productCard = tv({
	slots: {
		base: 'flex px-3 py-[2.5rem] md:px-4 md:py-3 gap-x-3 md:gap-x-4 rounded-m border border-onyx items-center relative group hover:border-white transition-colors',
		logo: 'basis-[40%] shrink-0 pr-3 md:pr-4 border-r border-onyx group-hover:border-white transition-colors',
		informationsContainer:
			'h-full w-full flex flex-col justify-center',
		linkExpand:
			'before:content-normal before:absolute before:w-full before:h-full before:top-0 before:left-0',
	},
	variants: {},
})

export type ProductCardVariants = VariantProps<typeof productCard>
